var _style, _polygon, _polygon2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMountain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x2018_\\xEB\\xEE\\xE9_x5F_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 782 109.41",
    style: {
      enableBackground: "new 0 0 782 109.41"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;fill:url(#SVGID_1_);}\r\n\t.st1{fill:#EDF3FA;}\r\n\t.st2{fill:#E7ECF2;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.1796,
    y1: 105.9999,
    x2: 389.1796,
    y2: -32.0332
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4658,
    style: {
      stopColor: "#F8FDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EAF8F9"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-56.97,109.3 -48.45,91.36 -32.41,77.5 -22.94,60.83 -8.64,47.17 1.15,33 24.01,19 43.88,25.15  51.68,21 81.45,35.33 85.62,43.2 112.93,47.5 123.79,52.84 141.67,42.33 150.68,34.33 172.7,20.09 187.29,25.83 190.14,25.15  213.28,33.38 215.28,32.13 234.43,41 246.44,39.13 261.83,42.53 293.41,30.87 303.16,21.33 327.35,14.33 352.21,27.17 373.23,14.33  374.69,14.33 401.22,-4 434.51,-24.5 460.31,-10.25 477.11,7.08 509.12,13.25 537.38,25 575.75,26.33 610.45,17.67 632.05,2.42  648.99,9.83 676.09,24.25 695.44,15.25 711.73,23.5 721.63,21.75 754.17,42.4 773.57,53.5 786.21,45.25 805.6,55.5 815.98,70.14  824.16,80.33 835.33,108.72 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-55,108.67 -44.84,95.6 -30.58,87.43 -23.83,71.09 -11.28,59.78 10.17,50.5 28,37.33 44.63,39.5  66.19,24.25 82.5,39 87.99,37.19 109.64,49.25 118.76,48.72 146.36,61.44 161.08,63.32 188.06,75.33 210.5,64 224.87,60.5  243,47.82 264.5,37 281.87,22.01 295.75,29.89 307.67,25.5 322.51,13.33 334.15,4.5 350.66,17.67 356.14,14.5 369.07,26  382.25,37.25 394.03,46.88 414.1,55.17 452.55,64.94 468.96,63.03 497.3,44.23 504.83,42.5 527.67,24.33 549.5,9.83 565,18.33  585.27,4.5 604.5,22.83 618.47,37.25 644.01,46.16 666.67,59.47 685.67,65.01 699.8,76.23 719.41,67.49 727.5,61.25 739.78,54.17  746.28,46.67 760.75,32.75 781.5,50.33 789.33,60.61 806.8,73.16 812,90.54 834.17,109.3 -55,109.3 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-43.67,109.41l18.07-27.49c0,0,0.21,0.02,0.52,0.04c0.31,0.03,0.73,0.06,1.13,0.08C-22,82-21,81-20.5,80.46 c0.17-0.18,0.34-0.36,0.51-0.55c0.34-0.37,0.68-0.77,1.03-1.2c0.14-0.15,0.28-0.3,0.42-0.45c4.78-5,12.42-13,12.42-13l6.63-2.18 L21,57.01l11.75-8.26L46.25,50l17.73-8.25l9.77,7l1.99-0.25l12.25,8.51l9.73,3.55l12.82,16.42l15.62,10.45l13.33-15.42l17.07-5.29 l11.5-9.22l11.31-6.15l1.78-1.35l4.68-5.31l6.41-4.77l7.08,5l6.72,6.96l10.86,6.04l12.61,8.38l12.27,2.37l9.83,3.47h7.53l9.72,9.98 l10.25-9.98h1.34l8.91-10.51l8.09-6.32l5.91-7.93l7.54-5.63l8.03-2.63l12.93,7.13l5.04,8.92l7.98,6.7l5.38,7.52l15.21,7.32 l12.01,2.75l13-4.55l6.75-12.98l11.58-6.75L420.5,43.2l12.94-5.37l6.79-6.97l17.27,8.63l14.34,14.49l21.55,14.27l4.99,10.78 l28.7,5.51l20.09-5.59l22.8-5.07l13.04-11.56l17-4.65l14.66-11.54l24.83,10.23l13.51,12.89l9.95,12.9l14.71,5.79l19.71,2.58 l12.75-5.68l9.29-13.33l16.09-8.64l13,6.39l8-1.79l12.83,11.82l12.18,7.01l13.26,11.09l17.08,3.01l12.14,3.86l5.17,4.45 L-43.67,109.41z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountain);
export default __webpack_public_path__ + "static/media/mountain.f592ed4d52535a9b8a90a6a9e7e57837.svg";
export { ForwardRef as ReactComponent };